import * as React from 'react';
import { CheckboxFilter } from '../../Filter/CheckboxFilter';
import { Trans } from '../../Trans';
import { AbstractFilterSectionView, FilterSectionViewProps } from '../AbstractFilterSectionView';
import { FilterInfo } from '../FilterInfo';
import { TelemetrySystemAttributeHelper } from './TelemetrySystemAttributeHelper';

interface FilterViewProps extends FilterSectionViewProps {
}

export class TelemetrySystemFilterView extends AbstractFilterSectionView<FilterViewProps> {
    public render() {
        return <div className="pf-filter-container">
            <div className="pf-filter-section">
                <div className="row">
                    <div className="pf-filter-wrapper -wide">
                        <div className="pf-filter-header"><Trans>Maschinen</Trans></div>
                        <CheckboxFilter filter={this.getFilter('Maschinen')}
                                        onChange={this.handleChange}
                                        options={this.collectAvailable('Maschinen')}/>
                    </div>
                    <div className="pf-filter-wrapper -wide">
                        <div className="pf-filter-header"><Trans id='Typ_Anwendung'>Typ. Anwendung</Trans></div>
                        <CheckboxFilter filter={this.getFilter(TelemetrySystemAttributeHelper.typicalApplication)}
                                        onChange={this.handleChange}
                                        options={this.collectAvailable(TelemetrySystemAttributeHelper.typicalApplication)}/>
                    </div>
                </div>
            </div>
            <FilterInfo {...this.props}/>
        </div>;
    }
}
